/*!
 *
 *  slide-scroll.js
 *
 */

var slideScroll = function(options) {
	var opt = options || {};
	var settings = {
		easing: 'fast',
		speed: 300,
		not: null
	};
	settings = $.extend(settings, opt);

	//var $a = $('a[href^="#"], a[href^="' + location.pathname + '#"], a[href^="' + location.protocol + '//' + location.hostname + location.pathname + '#"]').not('[href="#"]').not('' + settings.not);
	var a = 'a[href^="#"]:not('+ settings.not +'):not([href="#"]), a[href^="' + location.pathname + '#"], a[href^="' + location.protocol + '//' + location.hostname + location.pathname + '#"]';

	$(document).delegate(a, 'tap', function(e){
		e.preventDefault();
		var _target = $(this).attr('href');
		_target = _target.replace(location.protocol + '//' + location.hostname + location.pathname, '').replace(location.pathname, '');

		var _top = $(_target).offset().top;

		var _span = 15;
		if( origin.viewport === 'tablet' ){
			_span = 15;
		};
		if( origin.viewport === 'mobile' ){
			_span = 60;
		};

		var _pos = _top - _span;

		$(origin.st).animate({
			scrollTop: _pos
		}, {
			duration: settings.speed,
			easing: settings.easing,
			queue: false
		});
		return false;
	});
};

module.exports = slideScroll;


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/slide-scroll.js
// module id = 13
// module chunks = 0